import { FormHelperText } from "@mui/material";
import React from "react";

export default function CoreFormHelperText(props) {
  return (
    <FormHelperText style={{marginLeft: 0}} {...props}>
      {props.children}
    </FormHelperText>
  );
}
